import { red } from "@mui/material/colors";

const styles = {
  deliveryButton: {
    width: "90px",
    borderRadius: "0.5rem",
    height: "32px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  stack: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: "4px",
  },
};

export default styles;
